'use client'

import Button from '@eversports/klimt-primitives/Button'
import { RadioGroup, RadioGroupItem } from '@eversports/klimt-primitives/RadioGroup'
import Image from 'next/image'
import { useTranslations } from 'next-intl'
import { useState } from 'react'

import { Sheet, SheetTrigger } from '../../../../../../../../../components/Sheet'
import { BRAND_SELECTED_CLOCK_ICON, CLOCK_ICON } from '../../../../../../../../App.icons'
import FilterSheetContent from '../FilterSheetContent'

import formatTimeFilter from './helpers/format-time-filter'
import { START_TIME_OPTIONS } from './TimeFilter.constants'

interface Props {
  selectedTime: string | null
  updateFilter: (value: string) => void
  resetFilter: () => void
}

const TimeFilterSheet = ({ selectedTime, updateFilter, resetFilter }: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  const t = useTranslations('discover-sport-city')

  const timeIcon = selectedTime ? BRAND_SELECTED_CLOCK_ICON : CLOCK_ICON

  const toggleCalendar = () => setIsOpen(!isOpen)

  const handleSelect = (timeSelection: string) => {
    updateFilter(timeSelection)
    toggleCalendar()
  }

  const handleReset = () => {
    resetFilter()
    toggleCalendar()
  }

  return (
    <Sheet open={isOpen} onOpenChange={toggleCalendar}>
      <SheetTrigger className="order-3 flex flex-1 items-center gap-1 sm:hidden">
        <Button size="sm" variant={selectedTime ? 'tertiary-selected' : 'tertiary'}>
          <Image src={timeIcon} width={12} height={12} alt="" loading="lazy" />
          {selectedTime ? formatTimeFilter(selectedTime) : t('time')}
        </Button>
      </SheetTrigger>
      <FilterSheetContent title={t('starting-time')} reset={handleReset}>
        <RadioGroup value={selectedTime ?? undefined} onValueChange={handleSelect}>
          {START_TIME_OPTIONS.map((option) => {
            const optionStr = option.toString()
            return (
              <div
                key={option}
                className="flex cursor-pointer items-center gap-2 py-1 hover:bg-surface-primary hover:text-text-hover"
              >
                <RadioGroupItem id={optionStr} value={optionStr} />
                <label htmlFor={optionStr} className="w-full">
                  {formatTimeFilter(optionStr)}
                </label>
              </div>
            )
          })}
        </RadioGroup>
      </FilterSheetContent>
    </Sheet>
  )
}

export default TimeFilterSheet
